import { Item } from '@factorialco/deprecated-design-system'
import { A3InnuvaOrganizationalUnitsDocument } from 'generated/resources/graphql'

import DropdownSearchBar from 'modules/core/components/DropdownSearchBar'
import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useQuery } from 'modules/core/hooks/useQuery'
import i18n from 'modules/core/lib/i18n'

import { organizationalUnitsToOptions } from 'modules/payroll_integrations_a3innuva/lib/a3innuvaHelpers'
import { A3InnuvaWizardData } from 'modules/payroll_integrations_a3innuva/lib/types'

interface Props {
  data: A3InnuvaWizardData
  onDataChanged: (data: A3InnuvaWizardData) => void
}

export const OrganizationalUnits = ({ data, onDataChanged }: Props) => {
  const session = useCurrentSession()
  const { data: organizationalUnitsData, loading } = useQuery(A3InnuvaOrganizationalUnitsDocument, {
    variables: {
      companyId: session.company.id,
      currentUserId: session.access.userId,
    },
  })
  const organizationalUnits =
    organizationalUnitsData?.payrollIntegrationsA3innuva.organizationalUnitsConnection.nodes || []
  const options = organizationalUnitsToOptions(organizationalUnits)
  const organizationalUnitLabel = data.answers.organizational_unit_label ?? ''

  const onSelect = async (value: Item) => {
    onDataChanged({
      ...data,
      answers: {
        ...data.answers,
        organizational_unit_id: value['value'].toString(),
        organizational_unit_label: value['label'],
      },
    })
  }

  return (
    <DropdownSearchBar
      name={organizationalUnitLabel}
      placeholder={i18n.t(
        'app_store_v2.app_integrations.payroll_integrations_a3innuva.settings.steps.login.account_placeholder'
      )}
      label={i18n.t(
        'app_store_v2.app_integrations.payroll_integrations_a3innuva.settings.steps.login.account'
      )}
      onSelect={onSelect}
      labelNotFound={i18n.t('common.none')}
      data={options}
      searchLabel={i18n.t('common.search')}
      ellipsis={false}
      mandatory
      popoverWidth="s600"
      loading={loading}
    />
  )
}
